module.exports = __webpack_public_path__ + "static/media/EUR.7f678dca.svg";